import { useEffect } from 'react';

import { useThemeName } from '@/theme/useTheme';

/**
 * Mirror the active theme onto `<html data-theme="…">`, which drives every
 * CSS-variable color/geometry token. Call once high in the tree (see `App`).
 * The initial value is also set in `main.tsx` before first paint to avoid a
 * flash; this hook keeps the attribute in sync when the theme changes at runtime.
 */
// eslint-disable-next-line import/prefer-default-export
export const useApplyTheme = (): void => {
  const theme = useThemeName();
  useEffect(() => {
    document.documentElement.dataset.theme = theme;
  }, [theme]);
};
